import { Alert } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { publishMessages } from '../publish-messages';

/**
 * Warning when the station has connected accounts but none are available for publishing this content.
 */
export function NoPlatformsAlert() {
  return (
    <Alert severity="warning" sx={{ mt: 2 }}>
      <FormattedMessage {...publishMessages.panoramaNoConnectedPlatforms} />
    </Alert>
  );
}
